import { render, staticRenderFns } from "./WebPage.vue?vue&type=template&id=2e2f9722&scoped=true"
import script from "./WebPage.vue?vue&type=script&lang=js"
export * from "./WebPage.vue?vue&type=script&lang=js"
import style0 from "./WebPage.vue?vue&type=style&index=0&id=2e2f9722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f9722",
  null
  
)

export default component.exports